import { EPlatformFeature } from '@enums/campaign.enum';
import { TranslateService } from '@ngx-translate/core';
import { ICtaAnalyticsData } from '../../cta-analytics-table.interface';
import { IDeliverableCard } from '../cta-analytics-details-deliverable-card/cta-analytics-details-deliverable-card.interface';
import { BaseAnalyticsFormatter } from './base-analytics-formatter';

export class YoutubeStreamAnalyticsFormatter extends BaseAnalyticsFormatter {
  constructor(execution: ICtaAnalyticsData, translate: TranslateService) {
    super(EPlatformFeature.youtubeStream, execution, translate);
  }

  public generateDeliverableCardData(): IDeliverableCard[] {
    const title = this.processTitle();
    const gameplay = this.processGamePlay();
    const chatbot = this.processChatbot();
    const chatbotMulti = this.processChatbotMulti();
    const description = this.processDescription();
    const productPlacement = this.processProductPlacements();
    const showcase = this.processShowcase();
    const custom = this.processCustom();
    const talkingPoints = this.processTalkingPoints();
    const talkingPointAis = this.processTalkingPointAis();
    const visual = this.processVisual();
    const textTracking = this.processTextTracking();
    const audioTracking = this.processAudioTracking();

    return [
      ...(title ?? []),
      ...(gameplay ?? []),
      ...(chatbot ?? []),
      ...(chatbotMulti ?? []),
      ...(description ?? []),
      ...(productPlacement ?? []),
      ...(showcase ?? []),
      ...(custom ?? []),
      ...(talkingPoints ?? []),
      ...(talkingPointAis ?? []),
      ...(visual ?? []),
      ...(textTracking ?? []),
      ...(audioTracking ?? []),
    ];
  }
}
